<template>
  <div>
    <slot name="default" />
  </div>
</template>
